import React from 'react';
import styled from 'styled-components';

// Task 27 — karar modallarında (GoalDecisionModal/RevisionDecisionModal) ortak
// onay/revizyon(veya red) seçici. components/ui'da hazır bir Radio bileşeni
// YOK (yalnız CheckboxInput var) — bu yüzden CheckboxInput'un görsel dilini
// (Wrapper/Box/Label) izleyen, sayfaya özel küçük bir yerel bileşen.
const Group = styled.div`
  display: flex;
  gap: 18px;
  margin-bottom: 4px;
`;

const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.primary};
`;

const RadioInput = styled.input`
  width: 16px;
  height: 16px;
  accent-color: ${({ theme }) => theme.colors.primary.main};
  cursor: pointer;
`;

// opt.title (opsiyonel) — tarayıcı hover ipucu (P1: 360 likert çapa etiketleri
// FillFeedbackModal'dan bu yolla geçer); verilmezse davranış değişmez.
export default function DecisionRadio({ name, options, value, onChange }) {
  return (
    <Group role="radiogroup">
      {options.map((opt) => (
        <OptionLabel key={opt.value} title={opt.title}>
          <RadioInput
            type="radio"
            name={name}
            value={opt.value}
            checked={value === opt.value}
            onChange={() => onChange(opt.value)}
          />
          {opt.label}
        </OptionLabel>
      ))}
    </Group>
  );
}
